// Module
var code = `<svg
  viewBox="0 0 28 28"
  aria-hidden="true"
  class="_boltIcon_1bpga_9 _boltIcon_blue_1bpga_14"
  height="24"
  width="24"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs />
  <path
    d="M12.747 16.273h-7.46L18.925 1.5l-3.671 10.227h7.46L9.075 26.5l3.671-10.227z"
  />
</svg>
`;
// Exports
module.exports = code;